export function onInvalidSubmit(formElement: HTMLFormElement, selector = '[aria-invalid="true"]') {
  const targetElement = formElement.querySelector(selector) as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
  
  if(targetElement) {
    targetElement?.scrollIntoView({
      behavior: 'smooth'
    });
    targetElement.focus();
  }
}
